define('src/shim/backbone',[
    // "backbone",
    "backbone",
    "backbone.extension",
    "backbone.paginator",
    "backbone.validators",
    "src/plugins/underscore.extension",
    // "bootstrap",
], function(Backbone) {
    return Backbone;
});

